import { Model } from './model';
import { Paginated } from './paginated';
import * as moment from 'moment';
import { Moment } from 'moment';

export class StripeSubscription extends Model {
  idSubscription: number;
  UserBeneficiary?: UserBeneficiary;
  label: string;
  price: number;
  category: string;
  monthsInterval: number;
  createDate: Moment;
  nextBillingDate: Moment;
  deleted: boolean;
  metadata: any;
  afterDeserialize(input: any) {
    if (this.createDate) {
      this.createDate = moment(this.createDate);
    }
    if (this.nextBillingDate) {
      this.nextBillingDate = moment(this.nextBillingDate);
    }
  }
}

export class StripeSubscriptions extends Paginated {
  data: Array<StripeSubscription>;
}

export class UserBeneficiary extends Model {
  idUserBeneficiary: number;
  loginBeneficiary: string;
  nameBeneficiary: string;
  surnameBeneficiary: string;
  companyBeneficiary: string;
}
